module.exports = __webpack_public_path__ + "img/progress_078.e7e0ed69.png";